@switch (nachrichtState) {

    @case (NachrichtStateEnum.FORM) {
        <kokos-nachricht-form
                scrollIntoView
                [nachrichtPayload]="nachrichtPayload"
                [anhangMetadaten]="anhangMetadaten"
                [anliegenName]="anliegenName"
                [subanliegenName]="subanliegenName"
                [showUpload]="anhangErlaubt"
                [betreffEditable]="!nachrichtHistorie.length"
                [nachrichtHistorie]="nachrichtHistorie"
        ></kokos-nachricht-form>
    }
}